$(function(){

  // ドメイン設定
  var url = $(location).attr('href');
  var api_domain = '';
  if (url.indexOf('localhost') > -1) {
    api_domain = 'http://localhost:3001';
  } else if (url.indexOf('test') > -1) {
    api_domain = 'https://test.api.osouji.support';
  } else {
    api_domain = 'https://api.osouji.support';
  }

  $( 'a[href^="#"]' ).click( function(){
    // 移動先を0px調整する。0を30にすると30px下にずらすことができる。
    var adjust = 0;
    // スクロールの速度（ミリ秒）
    var speed = 400;
    // アンカーの値取得 リンク先（href）を取得して、hrefという変数に代入
    var href= $( this ).attr( "href" );
    console.log(href);
    // 移動先を取得 リンク先(href）のidがある要素を探して、targetに代入
    var target = $( href == "#" || href == "" ? 'html' : href );
    // 移動先を調整 idの要素の位置をoffset()で取得して、positionに代入
    var position = target.offset().top + adjust;
    // スムーススクロール linear（等速） or swing（変速）
    $( 'body,html' ).animate( { scrollTop: position }, speed, 'swing' );
    return false;
  });

    //固定ヘッダー対策
  $( window ).scroll( function() {
    var scroll = $( this ).scrollTop();
    var header_height = $( 'header.header > .container' ).outerHeight();
    if ( scroll > header_height ) {
      $( 'nav.header-nav' ).addClass( 'fixed' );
      $( '#content' ).addClass( 'fixed' );
    } else {
      $( 'nav.header-nav' ).removeClass( 'fixed' );
      $( '#content' ).removeClass( 'fixed' );
    }
  });

  // 加盟店ページ 星評価
  $( '.company__starts' ).raty({
    readOnly: true,
    number: 5,
    starHalf: '/assets/images/star-half.png',
    starOff: '/assets/images/star-off.png',
    starOn: '/assets/images/star-on.png'
  });

  // 加盟店一覧 もっとみる押下
  $( '.companies-box__more' ).click( function() {
    $( this ).hide();
    $( this ).closest( '.companies-box' ).find( '.companies-box__excerpt' ).remove();
    $( this ).closest( '.companies-box' ).find( '.companies-box__txt' ).show();
    $( this ).prev( '.companies-box__amount' ).hide();
    $( this ).next( '.companies-box__detail' ).slideDown();

    if ( ! $( '.companies-box .company-info__map' ).length ) {
      return false;
    }
    var map = $( this ).closest( '.companies-box' ).find( '.company-info__map' );
    var id = map.attr( 'id' );
    var lat = map.attr( 'data-lat' );
    var lng = map.attr( 'data-lng' );
    var zoom = map.attr( 'data-zoom' );
    var latlng = new google.maps.LatLng( lat, lng );
    var opts = {
      mapTypeControl: false,
      streetViewControl: false,
      zoom: Number( zoom ),
      center: latlng
    };

    var map = new google.maps.Map( document.getElementById( id ), opts );

    new google.maps.Marker({
      position: latlng,
      map: map
    });
  });

  // 加盟店一覧 「条件を変更して絞り込む」押下
  $( '.sidebar-search__ttl' ).on( 'click', function() {
    $( this ).siblings( '.sidebar-search__form' ).slideToggle();
  });

  // 加盟店一覧 モーダルを非表示
  $( '.companies-modal' ).on( 'click', function( event ) {
    if ( ! $( event.target ).closest( '.companies-modal__cnt' ).length ) {
      $( '.companies-modal' ).removeClass( 'is-active' );
      $( 'body' ).removeClass( 'is-modal-open' );
    }
  });
  
  // 加盟店一覧 「都道府県を再選択する」押下
  $( '.sidebar-search__btn' ).on( 'click', function() {
    $( '#modal_companies' ).addClass( 'is-active' );
    $( 'body' ).addClass( 'is-modal-open' );
  });

  // 加盟店一覧 都道府県ボタン押下
  $( '.sidebar-search__pref-btn' ).on( 'click', function() {
    if ( $( this ).hasClass( 'is-open' ) ) {
      $( this ).removeClass( 'is-open' );
      $( this ).find( 'span' ).text( '市区町村を選ぶ' );
      $( this ).next( '.sidebar-search__city' ).slideUp();
    } else {
      $( this ).addClass( 'is-open' );
      $( this ).find( 'span' ).text( '閉じる' );
      $( this ).next( '.sidebar-search__city' ).slideDown({
        start: function() {
          $( this ).css({ display: 'flex'});
        }
      });
    }
  });

  // 加盟店詳細 タブ切り替え
  $( '.company__tab-btn' ).click( function() {
    console.log('click');
    $( '.company__tab-btn' ).attr( 'aria-selected', false );
    $( this ).attr( 'aria-selected', true );
    $( '.company__tab-panel' ).removeClass( 'is-active' );
    var target_panel = $( this ).attr( 'aria-controls' );
    $( '#' + target_panel ).addClass( 'is-active' );
  });

  // 加盟店詳細ページ Google Map表示
  if ( $( '.company .company-info__map' ).length ) {
    var lat = $( '#map_lat' ).val();
    var lng = $( '#map_lng' ).val();
    var zoom = $( '#map_zoom' ).val();

    var latlng = new google.maps.LatLng( lat, lng );

    var opts = {
      mapTypeControl: false,
      streetViewControl: false,
      zoom: Number( zoom ),
      center: latlng
    };

    map = new google.maps.Map( document.getElementById( 'gmap' ), opts );

    marker = new google.maps.Marker({
      position: latlng,
      map: map
    });
  }

  //SPハンバーガーメニュー
  $(".openbtn").click(function () {
    $(this).toggleClass('active');

    if ($('.header-sp').hasClass('active')) {
      $('.header-sp').slideUp();
      $('.header-sp').removeClass('active');
    } else {
      $('.header-sp').slideDown();
      $('.header-sp').addClass('active');
    }

    $(".cta-btn").toggle(300);
    $('body').toggleClass('no-scroll');
  });

  $(window).resize(function () {
    var windowSize = $(window).width();
    if (windowSize > 896) {
      $('.openbtn').removeClass('active');
      $('.header-sp').removeClass('active');
      $('.header-sp').css('display', 'none');
      $('body').removeClass('no-scroll');
    }

  });

  $(".cancel-btn, .modal-overlay").click(function () {
    $(".popup-map").hide();
    $(".popup-category").hide();
    $('.modal-overlay').hide();
  });

  $(".search__item1").click(function () {
    $(".popup-map").show();
    $('.modal-overlay').show();
  });

  $(".search__item2").click(function () {
    $(".popup-category").show();
    $('.modal-overlay').show();
  });

  // まとめてチェックボタン
  $('[name="popup_all_check"]').change(function () {
    if ($(this).prop('checked') == true) {
      $('[name="company[segment_category_ids][]"]').prop("checked", true);
    } else {
      $('[name="company[segment_category_ids][]"]').prop("checked", false);
    }
  });

  $('.popup-map__area--ttl').click(function () {
    var windowSize = $(window).width();
    if (windowSize < 897) {
      $(this).closest('.popup-map__area').find('.popup-map__area--list-wrap').slideToggle();
    }
  });

  // 加盟店一覧 もっとみる押下
  $(this).on('click', '.company-more__btn', function () {
    $(this).hide();
    var $company_excerpt = $(this).closest('.companies-box').find('.company__excerpt');
    var company_txt = $company_excerpt.data('body');
    $company_excerpt.text(company_txt);
    $(this).closest('.company-more').next('.company-detail').slideDown();

    if (!$('.companies-box .company-info__map').length) {
      return false;
    }

    var map = $(this).closest('.companies-box').find('.company-info__map');
    var id = map.attr('id');
    var lat = map.attr('data-lat');
    var lng = map.attr('data-lng');
    var zoom = map.attr('data-zoom');
    var latlng = new google.maps.LatLng(lat, lng);
    var opts = {
      mapTypeControl: false,
      streetViewControl: false,
      zoom: Number(zoom),
      center: latlng
    };

    var map = new google.maps.Map(document.getElementById(id), opts);

    new google.maps.Marker({
      position: latlng,
      map: map
    });
  });

  // 加盟店一覧 モーダルを表示
  $('.sidebar-search__select, .sidebar-search__sp--box').click(function () {
    var target = $(this).data('target');

    $('#' + target).css({ 'z-index': '99', 'opacity': '1' }).show();
  });

  $('.cancel-btn').on('click', function() {
    $('.companies-modal').css({ 'z-index': '-1', 'opacity': '0' }).hide();
  });

  // 加盟店一覧 ブロック選択
  $(this).on('click', '.companies-modal__item', function () {
    var name = $(this).attr('name');
    var text = $(this).text();
    var data = {};
    data[name] = $(this).val();

    url = $(location).attr('search');
    console.log(url);
    if (name != 'city_id') {
      $.ajax({
        type: 'POST',
        url: api_domain + '/v1/areas/get_areas',
        data: data,
        dataType: 'json',
        headers: {
          'Authorization': 'bearer ' + gon.authorize_code
        }
      }).done(function (response) {
        console.log(response);
        if (response.status == "success") {
          if (response.type == 'prefecture') {
            var html = '';
            $.each(response.data, function (index, value) {
              html += '<button type="button" name="prefecture_id" value="' + value['prefecture_id'] + '" class="companies-modal__item">' + value['prefecture_name'] + '</button>';
            });
            $('.companies-modal__list').html(html);
          }

          if (response.type == 'city') {
            var html = '';
            var queryParams = getQueryParams(window.location.search);
            delete queryParams['company[segment_city_ids][]'];
            delete queryParams['company[segment_pref_ids][]'];

            $.each(response.data, function (index, value) {
              queryParams['company[segment_city_ids]'] = [value['city_id']];
              var newQueryString = $.param(queryParams);
              var href = window.location.pathname + '?' + newQueryString;
              html += '<a href="' + href + '" class="companies-modal__item">' + value['city_name'] + '</a>';
            });
            $('.companies-modal__list').html(html);
          }
        } else {
          alert('System Error');
        }
      });
    } else {
      $('[name="company[city_id]"]').val(data[name]);
      $('.sidebar-search__target-area-name').text(text);
      $('.search-result__area-result').children('.search-result__val').remove();
      $('.search-result__area-result').append('<span class="search-result__val">' + text + '</span>');
      modal_reset();
      search_form_submit();
    }
  });

  function getQueryParams(qs) {
    qs = qs.split('+').join(' ');

    var params = {},
      tokens,
      re = /[?&]?([^=]+)=([^&]*)/g;

    while (tokens = re.exec(qs)) {
      var key = decodeURIComponent(tokens[1]),
        value = decodeURIComponent(tokens[2]);

      // キーがすでに存在する場合は、値を配列に追加
      if (params.hasOwnProperty(key)) {
        // 既存の値が配列でない場合は、配列に変換
        if (!Array.isArray(params[key])) {
          params[key] = [params[key]];
        }
        params[key].push(value);
      } else {
        // キーが存在しない場合は、値を直接設定
        params[key] = value;
      }
    }

    return params;
  }

});


//////////////////
// WEBPACK FOOTER
// ./app/assets/javascripts/articles/base.js
// module id = 9
// module chunks = 0 1